import { render, staticRenderFns } from "./pipe-news.vue?vue&type=template&id=45df7be1&scoped=true"
import script from "./pipe-news.vue?vue&type=script&lang=js"
export * from "./pipe-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df7be1",
  null
  
)

export default component.exports